import React from "react";
import { Button, Icon, message, Modal } from "antd";
import style from "../../RulesSetting/index.module.scss";
import { resetDcGradeRule } from "service/score";
import { errorMessage } from "service/service";
import { ResultMessage } from "components/ResultMessage";

interface ResetBtnProps {
    courseNo: string;
    courseSeq: string;
    updateData: () => void;
}

const Index = ({ courseNo, courseSeq, updateData }: ResetBtnProps) => {
    //还原
    const onReset = () => {
        Modal.confirm({
            title: "确认还原?",
            content: "还原后，您已保存的成绩规则将重置为初始值。",
            onOk: async () => {
                try {
                    await resetDcGradeRule(courseNo, courseSeq);
                    await updateData();
                    message.success("还原成功");
                } catch (e) {
                    ResultMessage.error(errorMessage(e));
                }
            }
        });
    };

    return (
        <Button type="link" onClick={() => onReset()}>
            <Icon type="redo" className={style.setting} />
            还原
        </Button>
    );
};

export default Index;
